/**
 * PortalHomePage - 门户首页
 * @Author: ouyang
 * @Date: 2022/01/05 14:24
 * @LastEditTime: 2022/01/05 14:24
 * @Copyright: Copyright (c) 2020, Hand
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import formatterCollections from 'utils/intl/formatterCollections';
import intl from 'utils/intl';
// import { OLD_HOME_PAGE_URL } from 'utils/config';
import commonConfig from '@common/config/commonConfig';
// import { getCurrentLanguage, getAccessToken } from 'utils/utils';
import { getCurrentLanguage } from 'utils/utils';

@observer
export class PortalHomePage extends Component<any> {
  // 门户首页地址
  urlData: string = '';

  // token信息
  // accessToken: string | undefined;

  async componentWillMount() {
    // 新旧系统语言转换
    let hecLang: string = '';
    // const accessToken = getAccessToken();
    const language = getCurrentLanguage();
    if (language === 'zh_CN') {
      hecLang = 'ZHS';
    } else if (language === 'en_US') {
      hecLang = 'US';
    } else if (language === 'cht_CN') {
      hecLang = 'ZHT';
    } else if (language === 'may_MY') {
      hecLang = 'MS';
    }
    // this.urlData = `${commonConfig.OLD_HOME_PAGE_URL}?user_lang=${hecLang}&access_token=${accessToken}`;
    this.urlData = `${commonConfig.OLD_HOME_PAGE_URL}?user_lang=${hecLang}`;
  }

  /**
   * 跳转旧系统单据页面
   * @param urlPama 跳转链接
   */
  openOldPortal() {
    // window.open(this.urlData, '_blank');
    window.location.href = this.urlData;
  }

  render() {
    return (
      <React.Fragment>
        {/* <a className="portal-home-page" href={this.urlData}> */}
        <a className="portal-home-page" onClick={() => this.openOldPortal()}>
          {intl.get('hfins.common.portalHomePage').d('门户首页')}
        </a>
      </React.Fragment>
    );
  }
}

export default formatterCollections({ code: ['hfins.common'] })(PortalHomePage);
